import { PointerEvent, useCallback, useRef, useState } from 'react'

export default function useResizableSplit(defaultHeight: number) {
  const [splitHeight, setOverviewMapHeight] = useState<number>(defaultHeight)

  const dragRef = useRef<[number, number]>()
  const onDragStart = useCallback((e: PointerEvent<HTMLDivElement>) => {
    dragRef.current = [e.clientX, e.clientY]
    e.preventDefault()
  }, [])
  const onDrag = useCallback((e: PointerEvent<HTMLDivElement>) => {
    if (dragRef.current) {
      const diffY = (dragRef.current?.[1] || 0) - e.clientY
      dragRef.current = [e.clientX, e.clientY]
      setOverviewMapHeight(currentHeight =>
        Math.max(320, currentHeight + diffY)
      )

      e.preventDefault()
    }
  }, [])
  const onDragEnd = useCallback((e: PointerEvent<HTMLDivElement>) => {
    dragRef.current = undefined
    e.preventDefault()
  }, [])

  return { onDragStart, onDragEnd, onDrag, splitHeight }
}
